// extracted by mini-css-extract-plugin
export default {"root":"Breadcrumb-module--root--eu5Rd"};